// Quando o atalho do Capitao pode aparecer e como ele abre o painel.
// Usado pelo CopilotLauncher e pelo botao unico dos assistentes.
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const CONVERSATION_ROUTES = [
  'inbox_conversation',
  'conversation_through_inbox',
  'conversations_through_label',
  'team_conversations_through_label',
  'conversations_through_folders',
  'conversation_through_mentions',
  'conversation_through_unattended',
  'conversation_through_participating',
  'inbox_view_conversation',
];

// Rotas do fork onde o launcher do Capitão não deve aparecer (ex.: sobrepõe o
// botão "Próximo" do wizard do Disparador). Capitão não se aplica a essas telas.
const HIDDEN_ROUTES = [
  // Disparador
  'kanban_campaigns',
  'kanban_campaign_wizard',
  'kanban_campaign_detail',
  // Projetos
  'kanban_projects',
  'kanban_project_detail',
  // Atendimentos
  'kanban_appointments',
  // Flows
  'kanban_flows',
  'kanban_flow_execution_detail',
  'kanban_flow_history',
  'kanban_flow_builder',
  // Email Marketing
  'kanban_email',
  'kanban_email_wizard',
  'kanban_email_template_new',
  'kanban_email_template',
  'kanban_email_report',
];

export function useCopilotLauncher() {
  const route = useRoute();
  const { uiSettings, updateUISettings } = useUISettings();
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  const showCopilotLauncher = computed(() => {
    const isCaptainEnabled = isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.CAPTAIN
    );
    return (
      isCaptainEnabled &&
      !uiSettings.value.is_copilot_panel_open &&
      !CONVERSATION_ROUTES.includes(route.name) &&
      !HIDDEN_ROUTES.includes(route.name)
    );
  });

  const toggleCopilotPanel = () => {
    updateUISettings({
      is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
      is_contact_sidebar_open: false,
    });
  };

  return { showCopilotLauncher, toggleCopilotPanel };
}
